import Swal from "sweetalert2";

let lastShownMessage = "";
let lastShownAt = 0;

export const PROMOTION_MESSAGE_TRIGGERS = Object.freeze({
  QTY_CHANGE: "qty_change",
  ADD_PRODUCT: "add_product",
  PAGE_LOAD: "page_load",
  APPLY_PROMOTION: "apply_promotion",
});

export function resolvePromotionMessage(response) {
  if (!response || typeof response !== "object") {
    return "";
  }
  const raw =
    response.promotion_message ??
    (response.data &&
    typeof response.data === "object" &&
    !Array.isArray(response.data)
      ? response.data.promotion_message
      : undefined);
  if (raw == null) {
    return "";
  }
  return String(raw).trim();
}

export function canShowPromotionMessageForTrigger(trigger) {
  return (
    trigger === PROMOTION_MESSAGE_TRIGGERS.QTY_CHANGE ||
    trigger === PROMOTION_MESSAGE_TRIGGERS.ADD_PRODUCT
  );
}

export function notifyPromotionMessage(response, options = {}) {
  const hasTriggerOption = Object.prototype.hasOwnProperty.call(
    options,
    "trigger"
  );
  if (hasTriggerOption && !canShowPromotionMessageForTrigger(options.trigger)) {
    return false;
  }

  const msg = resolvePromotionMessage(response);
  if (!msg) {
    return false;
  }
  const now = Date.now();
  if (msg === lastShownMessage && now - lastShownAt < 3000) {
    return false;
  }
  lastShownMessage = msg;
  lastShownAt = now;
  Swal.fire({
    icon: "warning",
    title: "Promotion",
    text: msg,
    confirmButtonText: "OK",
  });
  return true;
}

export default notifyPromotionMessage;
